import { setWasmUrl } from "@lottiefiles/dotlottie-react";
import wasmUrl from "@lottiefiles/dotlottie-web/dist/dotlottie-player.wasm?url";

/**
 * Point dotlottie at the WASM blob bundled from our own origin instead of
 * letting it fetch from cdn.jsdelivr.net / unpkg.com which breaks CSP.
 *
 * Keep @lottiefiles/dotlottie-web pinned to the exact version that
 * @lottiefiles/dotlottie-react transitively depends on — if they drift,
 * the wasm binary and the JS loader may come from different releases.
 */
export function configureDotLottie() {
  setWasmUrl(wasmUrl);
}
